import { get } from "lodash/get";
import { handleError } from "helper/rest";
import { clientPublic, clientPublicV2 } from "helper/axios";

export const getResultProjectList = async ({ limit, page, token }) => {
  try {
    return await clientPublic
      .get(`project?limit=${limit}&page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const getOptionProject = async ({ limit, page, token }) => {
  try {
    return await clientPublic
      .get(`optiontype?kind=project&orderby=position`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
// api searh and get data project card
export const getSearchCardlist = async ({
  limit,
  page,
  params,
  token,
  sortBy,
}) => {
  try {
    return await clientPublicV2
      .post(
        `project/search?limit=${limit}&page=${page}&orderby=${sortBy?.type}|${sortBy?.follow}`,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const getListProject = async ({ params, token }) => {
  try {
    return await clientPublicV2
      .post(`project/search?orderby=created_at|desc`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
